import ProductStatusCard from "./productStatusCard/productStatusCard";
import { Container, Row, Col, Card } from "react-bootstrap";
import "../../../../../styles/typography.css";
import "./ProductStatus.css";
import { BsCircleFill } from "react-icons/bs";
import { formatDate } from "../../../../../utility/Formatdate";
import SampleModalWrapper from "../../../../../components/organisms/SampleModalWrapper/SampleModalWrapper";
import { useState } from "react";

const ProductStatus = ({ data = [] }) => {
  const [showModal, setShowModal] = useState(false);
  const [sample, setSample] = useState(null);
  return (
    <Card className="product-status-wrapper">
      <Container fluid>
        <div className="d-flex justify-content-between align-items-start mb-3">
          <h5 className="mb-0 header-default-style">Product Status</h5>
          <div className="d-flex align-items-center gap-3 status-dots">
            <span className="ms-3 me-2">
              <BsCircleFill color="#43B324" size={10} className="me-1" /> Due
              &gt; 10
            </span>
            <span>
              <BsCircleFill color="#E13B3B" size={10} className="me-1" /> Due
              &gt; 14
            </span>
          </div>
        </div>

        <div className="product-status-grid">
          <Row xs={2} sm={3} lg={6} className="g-3 me-0">
            {data.map((product, index) => (
              <Col key={index}>
                <ProductStatusCard
                  name={product.productTypeName}
                  total={product.totalSamples}
                  completed={product.completedSamples}
                  id={product.oldestSampleId}
                  date={formatDate(product.oldestSampleDate)}
                  dotColor={product.status}
                  setSample={setSample}
                  setShowModal={setShowModal}
                />
              </Col>
            ))}
          </Row>
        </div>
        <SampleModalWrapper sampleID={sample} setSampleID={setSample} showModal={showModal} setShowModal={setShowModal} />
      </Container>
    </Card>
  );
};

export default ProductStatus;
